export default "__VITE_ASSET__eb1ff05f__"